import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  Typography,
  Divider // Importamos Divider para separar secciones
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef} from 'react';
import api from "../api/api";

export default function Navbar() {
  const [openMainDrawer, setOpenMainDrawer] = useState(false);
  const [openProfileDrawer, setOpenProfileDrawer] = useState(false);
  const [image, setImage] = useState(null); // No usado en el código que enviaste, se puede quitar si no se usa.
  const [profile, setProfile] = useState(null);
  const fileInputRef = useRef(null); // No usado en el código que enviaste, se puede quitar si no se usa.
  const navigate = useNavigate();
  const role = profile?.role; // No usado en el código que enviaste.
  const location = useLocation();
  // Cargar usuario
   useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    api.get("/users/profile")
      .then(res => setProfile(res.data))
      .catch(() => {
        localStorage.removeItem("token");
      });
  }, [location, profile]);

  const logout = () => {
    localStorage.removeItem("token");
    setProfile(null);
    navigate("/login"); // Cambiado a "/" para que recargue la vista inicial sin el perfil
    // Opcionalmente: window.location.reload(); si necesitas una recarga completa
  };

  // Subir imagen
  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const res = await api.post("/files/upload-profile", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      setProfile(prev => ({ ...prev, profile_image: res.data.image_url }));
    } catch (error) {
      console.error("Error al subir imagen:", error);
    }
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setOpenMainDrawer(false);
    }
  };

  const handleNavClick = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(id), 300);
    } else {
      scrollToSection(id);
    }
  };

  const navLinks = [
    { text: 'Inicio', id: 'inicio' },
    { text: 'Servicios', id: 'servicios' },
    { text: 'Quiénes somos', id: 'nosotros' },
    { text: 'Contacto', id: 'contacto' },
  ];

  const linkStyle = {
    textDecoration: 'none',
    color: '#00796B',
    fontWeight: '500',
    fontFamily: 'Yu Gothic, sans-serif',
    fontSize: '1rem',
    position: 'relative',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: '#004D40',
    },
  };

  const loginButtonStyle = {
    backgroundColor: '#00796B',
    color: '#FAFAFA',
    fontWeight: 'bold',
    textTransform: 'none',
    borderRadius: '8px',
    padding: '8px 16px',
    '&:hover': {
      backgroundColor: '#004D40',
    },
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#FAFAFA',
          color: '#00796B',
          boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
          zIndex: 1000,
        }}
      >
        <Container>
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            {/* LOGO */}
            <Box
              sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => handleNavClick('inicio')}
            >
              <img
                src="/images/logodef.png"
                alt="OficiAR Logo"
                style={{ 
                  height: '45px',
                  width: '45px',
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginBottom: "10px" }}
              />
              <Typography variant="h4" sx={{ fontWeight: "bold", display: "flex" }}>
                <span style={{ color: "#00796B",  fontFamily: "'Yu Gothic', 'Sego', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'"}}>OficiAR</span>
              </Typography>
            </Box>
            
            {/* LINKS EN ESCRITORIO */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3, alignItems: 'center' }}>
              {navLinks.map((item) => (
                <Button
                  key={item.text}
                  sx={{ ...linkStyle, textTransform: 'none' }}
                  onClick={() => scrollToSection(item.id)}
                >
                  {item.text}
                </Button>
              ))}
              {!profile ? (
                <Button
                  sx={loginButtonStyle}
                  onClick={() => navigate('/login')}
                >
                  Iniciar sesión
                </Button>
              ) : (
                <Avatar
                  src={
                    profile.profile_image
                      ? `http://localhost:4000${profile.profile_image}`
                      : undefined
                  }
                  sx={{
                    width: 42,
                    height: 42,
                    cursor: 'pointer',
                    border: "2px solid #00796B"
                  }}
                  onClick={() => setOpenProfileDrawer(true)}
                />
              )}
            </Box>

            {/* BOTÓN MENÚ MÓVIL */}
            <IconButton
              sx={{ display: { xs: 'block', md: 'none' }, color: '#00796B' }}
              onClick={() => setOpenMainDrawer(true)}
            >
              <MenuIcon fontSize="large" />
            </IconButton>

            {/* DRAWER MÓVIL (Menú principal) */}
            <Drawer
              anchor="right"
              open={openMainDrawer}
              onClose={() => setOpenMainDrawer(false)}
              PaperProps={{
                sx: {
                  backgroundColor: '#FAFAFA',
                  width: '70%',
                  padding: "1rem",
                  display: "flex",
                  flexDirection: "column",
                },
              }}
            >
              <List sx={{ mt: 2, width: '100%' }}>

                {/* === INICIO: SECCIÓN DE PERFIL AUTENTICADO (En la parte superior) === */}
                {profile ? (
                  <>
                    <Box 
                      sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        my: 2 
                      }}
                    >
                      {/* AVATAR EDITABLE */}
                      <Box
                        sx={{
                          position: "relative",
                          width: 80, 
                          height: 80,
                          borderRadius: "50%",
                          cursor: "pointer",
                          overflow: "hidden",
                          "&:hover .editOverlay": { opacity: 1 }
                        }}
                        onClick={() => document.getElementById("mobile-avatar-input").click()}
                      >
                        <Avatar
                          src={
                            profile.profile_image
                              ? `http://localhost:4000${profile.profile_image}`
                              : undefined
                          }
                          sx={{
                            width: "100%",
                            height: "100%",
                            border: "3px solid #00796B"
                          }}
                        />
                        <Box
                          className="editOverlay"
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.55)",
                            color: "#FFF",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 12,
                            fontWeight: "bold",
                            textAlign: "center",
                            opacity: 0,
                            transition: "opacity 0.3s"
                          }}
                        >
                          Editar foto
                        </Box>
                      </Box>
                      <input
                        id="mobile-avatar-input" 
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          uploadImage(file);
                        }}
                      />
                      <Typography variant="subtitle1" sx={{ color: "#00796B", fontWeight: "bold", mt: 1 }}>
                        {profile.name}
                      </Typography>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    
                    {/* Opciones de perfil específicas de rol (Se quedan en la parte superior con el Avatar) */}
                    {profile.role === "trabajador" && (
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => navigate("/maintenance")}>
                          <ListItemText primary="Panel de Trabajador" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    {profile.role === "empleador" && (
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => navigate("/maintenance")}>
                          <ListItemText primary="Panel de Empleador" />
                        </ListItemButton>
                      </ListItem>
                    )}
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => navigate("/maintenance")}>
                        <ListItemText primary="Ver perfil" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => navigate("/maintenance")}>
                        <ListItemText primary="Configuración" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => navigate("/maintenance")}>
                        <ListItemText primary="Mis servicios" />
                      </ListItemButton>
                    </ListItem>

                    <Divider sx={{ my: 1 }} />
                  </>
                ) : (
                  // Opción INICIAR SESIÓN (si no hay perfil) - Se mantiene al principio si no hay avatar
                  <ListItem disablePadding>
                    <ListItemButton 
                      onClick={() => {
                        navigate('/login');
                        setOpenMainDrawer(false);
                      }}
                      sx={{
                        backgroundColor: '#00796B',
                        color: '#FAFAFA',
                        '&:hover': {
                          backgroundColor: '#004D40',
                        },
                        borderRadius: '8px',
                        mt: 1, // Pequeño margen superior para separación
                        mb: 2 // Margen inferior para separarlo de los links de navegación
                      }}
                    >
                      <ListItemText 
                        primary="Iniciar sesión" 
                        primaryTypographyProps={{ fontWeight: 'bold' }} 
                      />
                    </ListItemButton>
                  </ListItem>
                )}
                {/* === FIN: SECCIÓN DE PERFIL AUTENTICADO / INICIO SESIÓN === */}

                {/* Opciones de Navegación principales (debajo del perfil o botón de login) */}
                {navLinks.map((item) => (
                  <ListItem disablePadding key={item.text}>
                    <ListItemButton onClick={() => handleNavClick(item.id)}>
                      <ListItemText primary={item.text} />
                    </ListItemButton>
                  </ListItem>
                ))}
                
                {/* Botón de Cerrar Sesión (Si existe el perfil, lo ponemos al final de todo) */}
                {profile && (
                    <ListItem disablePadding sx={{ mt: 2 }}>
                      <ListItemButton
                        onClick={() => {
                          logout(); // Usamos la función logout
                          setOpenMainDrawer(false); // Cierra el Drawer
                        }}
                        sx={{
                          bgcolor: "#ef9a9a", 
                          "&:hover": { bgcolor: "#e57373" },
                          borderRadius: 1,
                        }}
                      >
                        <ListItemText 
                          primary="Cerrar sesión" 
                          primaryTypographyProps={{ 
                            sx: { color: "#D32F2F", fontWeight: "bold" } 
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                )}
              </List>
            </Drawer>

          </Toolbar>
        </Container>
      </AppBar>

      {/* DRAWER PERFIL (Original, lo mantienes para la versión de escritorio) */}
      <Drawer
        anchor="right"
        open={openProfileDrawer}
        onClose={() => setOpenProfileDrawer(false)}
        PaperProps={{
          sx: { width: 300, backgroundColor: "#FAFAFA", padding: 2 }
        }}
      >
        {profile && (
          <>
            {/* Avatar editable (Original, ahora sólo para el drawer del perfil de escritorio) */}
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2 }}>
              <Box
                sx={{
                  position: "relative",
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  cursor: "pointer",
                  overflow: "hidden",
                  "&:hover .editOverlay": { opacity: 1 }
                }}
                onClick={() => document.getElementById("avatar-input-desktop").click()} // Cambiado ID
              >
                <Avatar
                  src={
                    profile.profile_image
                      ? `http://localhost:4000${profile.profile_image}`
                      : undefined
                  }
                  sx={{
                    width: "100%",
                    height: "100%",
                    border: "3px solid #00796B"
                  }}
                />
                <Box
                  className="editOverlay"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.55)",
                    color: "#FFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    opacity: 0,
                    transition: "opacity 0.3s"
                  }}
                >
                  Editar foto
                </Box>
              </Box>
              <input
                id="avatar-input-desktop" // Cambiado ID
                type="file"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  uploadImage(file);
                }}
              />
              <Typography variant="h6" sx={{ color: "#00796B", fontWeight: "bold", mt: 2 }}>
                {profile.name}
              </Typography>
              <Typography sx={{ color: "#555", fontSize: 14 }}>
                {profile.email}
              </Typography>
            </Box>
            <List sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 1 }}>
              {/* Se elimina el avatar repetido aquí, estaba duplicado en tu código original */}
              
              <ListItem disablePadding>
                <ListItemButton onClick={() => navigate("/maintenance")}>
                  <ListItemText primary="Ver perfil" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => navigate("/maintenance")}>
                  <ListItemText primary="Configuración" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => navigate("/maintenance")}>
                  <ListItemText primary="Mis servicios" />
                </ListItemButton>
              </ListItem>
              {profile?.role === "admin" && (
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => navigate("/admin/feedback")}
                  sx={{
                    bgcolor: "#00796B",
                    "&:hover": { bgcolor: "#005f54" },
                    borderRadius: 1,
                    mt: 1
                  }}
                >
                  <ListItemText
                    primary="Panel de Feedback"
                    primaryTypographyProps={{
                      sx: { color: "white", fontWeight: "bold" }
                    }}
                  />
                </ListItemButton>
              </ListItem>
            )}
              {/* Cerrar sesión (Original) */}
              <ListItem disablePadding sx={{ mt: 2, width: '100%' }}>
                <ListItemButton
                  onClick={() => {
                    logout();
                    setOpenProfileDrawer(false); // Cierra el drawer
                  }}
                  sx={{
                    bgcolor: "#ef9a9a", 
                    "&:hover": { bgcolor: "#e57373" },
                    borderRadius: 1,
                  }}
                >
                  <ListItemText 
                    primary="Cerrar sesión" 
                    primaryTypographyProps={{ 
                      sx: { color: "#D32F2F", fontWeight: "bold" } 
                    }} 
                  />
                </ListItemButton>
              </ListItem>             
            </List>
          </>
        )}
      </Drawer>
    </Box>
  );
}